export const AllowedDomainsAndAttributeMapping = '/admin-guide/configuring-the-saml-integration#step-23-configure-automation-suite';

export const ReadArticleLink = '/admin-guide/managing-access#managing-service-level-roles';
